import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/store'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Login from './views/Login'
import Help from './views/Help'
import Contact from './views/Contact'
import Abstract from './views/Abstract'
import DynamicForm from './components/abstract/DynamicForm'
import Authors from './components/author/Overview'
import Author from './views/Author'
import AuthorForm from './components/author/AuthorForm'
import InstituteForm from './components/author/InstituteForm'
import Submit from './components/abstract/Submit'
import SubmitSuccess from './components/abstract/SubmitSuccess'
import Confirm from "./components/confirmation/Confirm";
import stripe_checkout from "./components/payment/stripe_checkout";
import stripe_success from "./components/payment/stripe_success";

//SPECIAL EBMT
import AbstractType from "./components/special/AbstractType";
import AbstractType2 from "./components/special/AbstractType2";

Vue.use(Router);
Vue.use(Vuex);

const router = new Router({
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      component: Home
    },
    {
      path: '/abstracttype',
      component: AbstractType
    },
    {
      path: '/abstracttype2',
      component: AbstractType2
    },
    {
      path: '/abstract/:id',
      component: Abstract,
      children: [
        {
          path: 'dynamic/:pageid',
          name: 'dynamic',
          component: DynamicForm
        },
        {
          path: 'payment',
          component: stripe_checkout,
        },
        {
          path: 'payment/success',
          component: stripe_success,
        },
        {
          path: 'authors',
          component: Authors,
        },
        {
          path: 'authors/author/add',
          component: AuthorForm
        },
        {
          path: 'authors/author/:authorid',
          component: Author,
          children: [
            {
              path: 'edit',
              name: 'authoredit',
              component: AuthorForm,
            },
            {
              path: 'presenterchange',
              name: 'presenterchange',
              component: AuthorForm,
            },
            {
              path: 'institute/add',
              component: InstituteForm,
            },
            {
              path: 'institute/:instituteid/edit',
              component: InstituteForm,
            },
          ]
        },
        {
          path: 'submit',
          name: 'submit',
          component: Submit
        },
        {
          path: 'preview',
          name: 'preview',
          component: Submit
        },
        {
          path: 'submitsuccess',
          name: 'submitsuccess',
          component: SubmitSuccess
        },
        {
          path: 'confirm',
          component: Confirm,
          name: 'confirm',
          // Die ganzen subroutinen müssen umgeleitet werden, sonst landet man sonstwo
          children: [
            {
              path: 'authors/author/add',
              redirect: '../authors/author/add',
            },
            {
              path: 'authors/author/:authorid/edit',
              redirect: '../authors/author/:authorid/edit',
            },
            {
              path: 'authors/author/:authorid/presenterchange',
              redirect: '../authors/author/:authorid/presenterchange',
            },
            {
              path: 'authors/author/:authorid/institute/add',
              redirect: '../authors/author/:authorid/institute/add',
            },
            {
              path: 'authors/author/:authorid/institute/:instituteid/edit',
              redirect: '../authors/author/:authorid/institute/:instituteid/edit',
            },
          ]
        },
      ]
    },
    {
      path: '/help',
      component: Help
    },
    {
      path: '/contact',
      component: Contact
    },
    {
      path: '*',
      redirect: '/home'
    }
  ],
})

router.beforeEach((to, from, next) => {
  if (to.path != '/login') {
    let token = location.search.match(/token=([^&]*)/) || false;
    if (token[1]) {
      localStorage.setItem('x-api-key', token[1]);
      store.commit('SET_TOKEN', {token: token[1]});
      store.state.login.success = true;
      window.history.pushState({}, document.title, process.env.VUE_APP_PATH_CONFIG);
      next();
      // Vue.axios.defaults.headers.common['x-api-key'] = token[1];
    } else if (!localStorage.getItem('x-api-key')) {
      localStorage.removeItem('x-api-key');
      store.state.login.success = false;
      next('/login');
    } else {
      store.commit('SET_TOKEN', {token: localStorage.getItem('x-api-key')});
      store.state.login.success = true;
      next();
    }
  } else {
    next();
  }
})
export default router
